import React from 'react';
import { SlotsStatus } from '../../../../../types/types';
import { getFilterDateFn } from '../../../../../utils/dateAndTime/dateAndTime';
import { WeeklyTimeSlotsLayoutViewModel } from '../../../ViewModel/bodyViewModel/bodyViewModel.types';
import { TimeSlotsSelectionViewModel } from '../../../ViewModel/timeSlotsSelectionViewModel/timeSlotsSelectionViewModel';
import ErrorNotification from '../../ErrorNotification/ErrorNotification';
import SectionHeader from '../../SectionHeader/SectionHeader';
import TimeSlotsNotification from '../../TimeSlotsNotification/TimeSlotsNotification';
import { TimeSlotsSelectionDisplayMode } from '../../TimeSlotsSelection/constants';
import TimeSlotsSelection from '../../TimeSlotsSelection/TimeSlotsSelection';
import TimezoneSelection from '../../TimezoneSelection/TimezoneSelection';
import WeekAvailability, {
  DayWithoutSlotsIndicationFactory,
  DayWithSlotsFactory,
} from '../WeekAvailability/WeekAvailability';
import WeekPicker from '../WeekPicker/WeekPicker';
import { DataHooks } from './constants';
import { classes, st } from './WeeklyTimeSlotsLayout.st.css';

export interface WeeklyTimeSlotsLayoutProps {
  viewModel: WeeklyTimeSlotsLayoutViewModel;
  errorNotificationText: string;
}

const WeeklyTimeSlotsLayout: React.FC<WeeklyTimeSlotsLayoutProps> = ({
  viewModel: {
    bodyTitle,
    slotsStatus,
    timeSlotsNotificationViewModel,
    timezoneSelectionViewModel,
    noAvailableSlotsViewModel,
    weekPickerViewModel,
    slotsPerDays,
    pricingPlanExpirationDate,
  },
  errorNotificationText,
}) => {
  const dayWithSlotsFactory: DayWithSlotsFactory<
    TimeSlotsSelectionViewModel
  > = ({ slotsViewModel, date }) =>
    slotsViewModel.timeSlots.length ? (
      <TimeSlotsSelection
        date={date}
        viewModel={slotsViewModel}
        displayMode={TimeSlotsSelectionDisplayMode.Column}
      />
    ) : null;

  const dayWithoutSlotsIndicationFactory: DayWithoutSlotsIndicationFactory<
    TimeSlotsSelectionViewModel
  > = ({ slotsViewModel, text }) =>
    slotsStatus === SlotsStatus.AVAILABLE_SLOTS &&
    !slotsViewModel.timeSlots.length
      ? text
      : null;

  return (
    <div
      className={st(classes.root)}
      data-hook={DataHooks.WeeklyTimeSlotsLayout}
    >
      <SectionHeader
        title={bodyTitle}
        suffix={
          <TimezoneSelection
            viewModel={timezoneSelectionViewModel}
            dataHook={DataHooks.Timezone}
          />
        }
      />
      <ErrorNotification errorText={errorNotificationText} />
      <WeekPicker viewModel={weekPickerViewModel!} />
      {slotsStatus === SlotsStatus.AVAILABLE_SLOTS ? (
        <TimeSlotsNotification viewModel={timeSlotsNotificationViewModel} />
      ) : null}
      <WeekAvailability
        slotsPerDays={slotsPerDays!}
        slotsStatus={slotsStatus}
        noAvailableSlotsViewModel={noAvailableSlotsViewModel!}
        dayWithSlotsFactory={dayWithSlotsFactory}
        dayWithoutSlotsIndicationFactory={dayWithoutSlotsIndicationFactory}
        filterDate={getFilterDateFn(pricingPlanExpirationDate)}
      />
    </div>
  );
};

export default WeeklyTimeSlotsLayout;
